import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { RedirectService } from '../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class ReferralRedirectGuard  {
  constructor(private redirectService: RedirectService) {}

  canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    return this.redirectService.redirectTo(['auth', 'signup', 'r', next.params.ref, 'koabc'], {
      utm_source: 'picflow',
      utm_medium: 'referral',
    });
  }
}
